module.exports = {
    attributeTypes: require('./src/attributeTypes'),
    operators: require('./src/operators'),
    executor: require('./src/query-executor'),
    hasConditionsForQuestion: require('./src/hasConditionsForQuestion'),
    unflatten: require('./src/unflatten'),
    clearValuesForUnmetConditions: require('./src/clearValuesForUnmetConditions')
}